import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import RegistrationPage from "./views/registration/registration.page.js";
import LoginPage from "./views/login/login.page.js";
import DashboardPage from "./views/dashboard/dashboard.page.js";
import AdminEventsPage from "./views/adminpanel/adminEvents.page.js";
import AdminUsersPage from "./views/adminpanel/adminUsers.page.js";
import AdminGamesPage from "./views/adminpanel/adminGames.page.js";
import AdminTournamentPage from "./views/adminpanel/adminTournaments.page.js";
import { Box, createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import Navigation from "./views/navigation/navigation";
import AuthProvider from "./context/auth.context.js";
import PrivateRoute from "./util/privateRoute.js";
import "./App.css";
import FaqPage from "./views/faq/faq.page.js";
import TournamentPage from "./views/tournament/tournament.page.js";
import ProfileSettingsPage from "./views/profile/profileSettings.page.js";
import OrderPage from "./views/order/order.page.js";
import AdminTeamsPage from "./views/adminpanel/adminTeams.page.js";
import ProfilePage from "./views/profile/profile.page.js";
import AdminAwardsPage from "./views/adminpanel/adminAwards.page.js";
import { WebSocketProvider } from "./context/websocket.context.js";
import ChatPage from "./views/chat/chat.page.js";
import LocationPage from "./views/location/location.page.js";
import AdminPollsPage from "./views/adminpanel/adminPolls.page.js";
import RankingPage from "./views/ranking/ranking.page.js";
import GatherPage from "./views/gather/gather.page.js";

function App() {
  const darkTheme = createTheme({
    typography: {
      fontFamily: "Afacad Flux, sans-serif",
    },
    palette: {
      mode: "dark",
      primary: {
        light: "#ff824b",
        main: "#ed672c",
        dark: "#ab3f0f",
        contrastText: "#fff",
      },
      secondary: {
        light: "#4765a1",
        main: "#1a3f8a",
        dark: "#122c60",
        contrastText: "#000",
      },

      background: {
        default: "#121212",   // Seitenhintergrund (body)
      },
    },
  });

  return (
    <div className="App">
      <Router>
        <ThemeProvider theme={darkTheme}>
          <CssBaseline />
          <WebSocketProvider>
            <AuthProvider>
              <Box sx={{ display: "flex" }}>
                <Navigation />
                <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                  <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/register" element={<RegistrationPage />} />
                    <Route element={<PrivateRoute />}>
                      <Route path="/" element={<DashboardPage />} />
                    </Route>
                    <Route element={<PrivateRoute />}>
                      <Route path="/order" element={<OrderPage />} />
                    </Route>
                    <Route element={<PrivateRoute />}>
                      <Route path="/ranking" element={<RankingPage />} />
                    </Route>
                    <Route element={<PrivateRoute />}>
                      <Route path="/gather" element={<GatherPage />} />
                    </Route>
                    <Route element={<PrivateRoute />}>
                      <Route path="/faq" element={<FaqPage />} />
                    </Route>
                    <Route element={<PrivateRoute />}>
                      <Route path="/tournament" element={<TournamentPage />} />
                    </Route>
                    <Route element={<PrivateRoute />}>
                      <Route
                        path="/profile/settings"
                        element={<ProfileSettingsPage />}
                      />
                    </Route>
                    <Route element={<PrivateRoute />}>
                      <Route path="/profile" element={<ProfilePage />} />
                    </Route>
                    <Route element={<PrivateRoute />}>
                      <Route path="/chat" element={<ChatPage />} />
                    </Route>
                    <Route element={<PrivateRoute />}>
                      <Route path="/location" element={<LocationPage />} />
                    </Route>
                    <Route element={<PrivateRoute />}>
                      <Route
                        path="/admin/events"
                        element={<AdminEventsPage />}
                      />
                    </Route>
                    <Route element={<PrivateRoute />}>
                      <Route
                        path="/admin/awards"
                        element={<AdminAwardsPage />}
                      />
                    </Route>
                    <Route element={<PrivateRoute />}>
                      <Route path="/admin/users" element={<AdminUsersPage />} />
                    </Route>
                    <Route element={<PrivateRoute />}>
                      <Route path="/admin/teams" element={<AdminTeamsPage />} />
                    </Route>
                    <Route element={<PrivateRoute />}>
                      <Route path="/admin/games" element={<AdminGamesPage />} />
                    </Route>
                    <Route element={<PrivateRoute />}>
                      <Route path="/admin/polls" element={<AdminPollsPage />} />
                    </Route>
                    <Route element={<PrivateRoute />}>
                      <Route
                        path="/admin/tournaments"
                        element={<AdminTournamentPage />}
                      />
                    </Route>
                  </Routes>
                </Box>
              </Box>
            </AuthProvider>
          </WebSocketProvider>
        </ThemeProvider>
      </Router>
    </div>
  );
}

export default App;
